import {createActionSet} from './actionHelper';

export const GET_TABLE = createActionSet('GET_TABLE');

export const GET_CARD = createActionSet('GET_CARD');

export const DOWNLOAD_PDF = createActionSet('DOWNLOAD_PDF');

export const DOWNLOAD_EXCEL = createActionSet('DOWNLOAD_EXCEL');

export const LOGIN = createActionSet('LOGIN');

export const GET_BUILDING  = createActionSet('GET_BUILDING');

export const CHECK_OUT = createActionSet('CHECK_OUT');

export const GET_ANA_CARDS = createActionSet('GET_ANA_CARDS');

export const GET_ANALYTICS_BAR = createActionSet('GET_ANALYTICS_BAR');

export const GET_ANALYTICS_PURPOSE = createActionSet('GET_ANAYLYTICS_PURPOSE');

export const GET_ANALYTICS_ADDRESS = createActionSet('GET_ANALYTICS_ADDRESS');

export const CHANGE_PASSWORD = createActionSet('CHANGE_PASSWORD');

export const ADD_EMP = createActionSet('ADD_EMP');

export const EDIT_EMP = createActionSet('EDIT_EMP');

export const GET_EMP = createActionSet('GET_EMP');

export const SEARCH_EMP = createActionSet('SEARCH_EMP');

export const DELETE_EMP = createActionSet('DELETE_EMP');

export const FORGOT_PASSWORD = createActionSet('FORGOT_PASSWORD');

export const RESET_PASSWORD = createActionSet('RESET_PASSWORD');

export const UPLOAD_BULK_EMP = createActionSet('UPLOAD_BULK_EMP');

export const ACCESS_CARD = createActionSet('ACCESS_CARD');

export const SEARCH_ACCESS_CARD = createActionSet('SEARCH_ACCESS_CARD');

export const UPDATE_ACCESS_CARD  = createActionSet('UPDATE_ACCESS_CARD');

export const GET_TABLE_SOCKET = createActionSet('GET_TABLE_SOCKET');

export const GET_BLOCKLIST = createActionSet('GET_BLOCKLIST');

export const ADD_BLOCKLIST_ENTRY = createActionSet('ADD_BLOCKLIST_ENTRY');

export const REMOVE_BLOCKLIST_ENTRY = createActionSet('REMOVE_BLOCKLIST_ENTRY');

export const LOOKUP_BLOCKLIST_NUMBER = createActionSet('LOOKUP_BLOCKLIST_NUMBER');

export const GET_BLOCKLIST_INDEX = createActionSet('GET_BLOCKLIST_INDEX');

export const GET_VISITOR_HISTORY = createActionSet('GET_VISITOR_HISTORY');

export const UPDATE_BLOCKLIST_SETTINGS = createActionSet('UPDATE_BLOCKLIST_SETTINGS');
